import { Spinner, View } from "tamagui";

export const Loader = () => {
  return (
    <View justifyContent="center" alignItems="center" width={"100%"}>
      <Spinner color={"$green-500"} size={"large"} />
    </View>
  );
};
